import { getUniqueId } from '@ankr.com/common';

export const WALLET_CACHE_TAGS = {
  account: `account-${getUniqueId()}`,
};
